/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-03 17:48:55
 * @LastEditors: pj
 * @LastEditTime: 2023-02-14 16:35:09
 */
import { index_gift, game_recommend, send_captcha } from '@/api/home'
import { user_info, safety_questions } from '@/api/user'

const api = {
    state: () => ({

    }),
    // 设置属性状态
    mutations: {},
    actions: {
        // 获取密保问题
        async get_safety_questions ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                safety_questions(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 侧栏礼包【领取】
        async get_index_gift ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                index_gift(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 侧栏游戏推荐【下载】
        async get_game_recommend ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                game_recommend(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 图形验证码
        async get_send_captcha ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                send_captcha(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
};
export default api